var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cls from 'classnames';
import { SectionItem } from './SectionItem';
export function SectionItemMore(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    const finalClassName = cls('WhSearch-SectionItem--more', className);
    return React.createElement(SectionItem, Object.assign({ className: finalClassName }, props));
}
//# sourceMappingURL=SectionItemMore.js.map